// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEnquiry_root__29quK","marketplaceColorStroke":"IconEnquiry_marketplaceColorStroke__cZUjX"};